/* DSL Engagement-score — accumulate scroll-depth, time-on-page, clicks → score */
(function(){
  var KEY = "dsl_engagement";
  var s = (function(){ try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch(e){ return {}; } })();
  s.score = s.score || 0; s.last = Date.now();
  var maxScroll = 0;
  function depth(){
    var p = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
    if (p > maxScroll) maxScroll = p;
  }
  window.addEventListener("scroll", depth, {passive: true});
  document.addEventListener("click", function(){ s.score += 1; });
  setInterval(function(){ s.score += 1; }, 30000);
  addEventListener("pagehide", function(){
    s.score += Math.floor(maxScroll * 5);
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch(e){}
  }, {once: true});
})();